<template>
  <v-card class="white item" :to="item.to" tile flat>
    <img
      class="d-flex mx-auto item-img pa-3 pa-lg-4"
      :src="files + item.img"
      v-if="item.img"
    />

    <div
      class="d-flex align-center justify-center px-3 item-caption"
      v-if="item.title"
    >
      <div
        class="
          align-center
          text-body-1 text-md-h6
          grey--text
          font-weight-bold
          text-center
          item-title
        "
      >
        {{ item.title }}
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  box-shadow: 0px 17px 51px rgba(0, 0, 0, 0.05),
    0px 5.125px 15.375px rgba(0, 0, 0, 0.0260636),
    0px 2.12866px 6.38599px rgba(0, 0, 0, 0.02),
    0px 0.769896px 2.30969px rgba(0, 0, 0, 0.0139364) !important;
  .item-img {
    aspect-ratio: 4 / 3;
    border-bottom: 1px solid var(--v-secondary-lighten4);
    object-fit: contain;
    -o-object-fit: contain;
    width: 100%;
    @media screen and (max-width: 600px) {
      width: 60%;
    }
  }
  .item-caption {
    height: 83px;
    @media screen and (max-width: 960px) {
      height: 77px;
    }
    .item-title {
      -webkit-box-orient: vertical;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      max-height: 63px;
      overflow: hidden;
      transition: all 0.1s linear;
      @media screen and (max-width: 960px) {
        max-height: 57px;
      }
    }
  }
  &:hover {
    .item-caption {
      .item-title {
        color: var(--v-primary-base) !important;
      }
    }
  }
}
</style>
